module.exports = __webpack_public_path__ + "img/showcase-video.c90ec064.jpg";